import {ObjectGroupSettlementOption} from './object-group-settlement-option';
import {vuei18n} from '../plugins/i18n';

export const objectGroupSettlementOptions = [
  {value: ObjectGroupSettlementOption.TWO_SETTLEMENTS, text: vuei18n.t('objectGroup.settlementOptionTwoSettlements')},
  {value: ObjectGroupSettlementOption.ONE_SETTLEMENT_COMMISSION_AFTER_ARRIVAL, text: vuei18n.t('objectGroup.settlementOptionOneSettlementAfterArrival')},
  {value: ObjectGroupSettlementOption.ONE_SETTLEMENT_COMMISSION_AFTER_DEPARTURE, text: vuei18n.t('objectGroup.settlementOptionOneSettlementAfterDeparture')}
];
